<template>
  <div>
    <el-dialog
        title="大赛规则"
        :visible.sync="dialogVisible"
        custom-class="commitment-dialog"
        >
        <span v-html="content"></span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" >取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: 'dataSource',
  props: ['dataSourceVisible'],
  data () {
    return {
      content: null,
      dialogVisible: false
    }
  },
  watch: {
    dataSourceVisible (newVal, oldVal) {
      this.dialogVisible = newVal
    },
    dialogVisible (newVal, oldVal) {
      this.$parent.dataSourceVisible = newVal
    }
  },
  mounted () {
    this.axios.get(this.siteURL + '/actuator/data/selectArticleDataList?siteId=' + this.siteId + '&nameEn=Confidentiality Commitment', {}).then(res => {
      if (res.data.code === 200) {
        this.content = res.data.data[0].content
      } else {
        this.$message(res.data.msg)
      }
    })
  },
  methods: {
    getArea (type, parentId) {
      var api = this.systemURL + ''
      this.axios.get(api, {}).then((res) => {
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/commitment.vue